import moment from 'moment-jalaali'
import React, { memo, useEffect, useRef } from 'react'
import Modal from './Modal'

function CarChangesModal({ setShowModal, carChanges }) {
  const modalContentRef = useRef(null)

  const clickOnOutside = (e) => {
    if (modalContentRef.current === e.target) {
      setShowModal(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', clickOnOutside)
    return () => {
      document.removeEventListener('mousedown', clickOnOutside)
    }
  }, [])

  return (
    <Modal isLargeModal={true} isFullContent={true}>
      <div ref={modalContentRef}>
        {/*header*/}

        <div className="flex items-center justify-between p-3 md:p-6">
          <h3 className="text-xl md:text-2xl font-semibold text-center dark:text-slate-200">
            تعویضی های انجام شده
          </h3>
          <i
            className={
              'icon-close-circle bg-light-gray dark:bg-slate-600 dark:text-amber-50 w-10 h-10 flex items-center justify-center rounded-md text-2xl mr-4 cursor-pointer'
            }
            onClick={() => setShowModal(false)}
          />
        </div>

        {/*list*/}
        <div className="flex flex-wrap gap-x-8 gap-y-6 pb-2 max-h-[500px] overflow-auto">
          <table className="w-full text-right table-fixed">
            <thead>
              <tr className="bg-[#F5FAFF] dark:bg-slate-500 text-lg sticky top-0 z-10">
                <th className="p-4 dark:text-white">نوع سرویس</th>
                <th className="p-4 dark:text-white">برند</th>
                <th className="p-4 dark:text-white">تاریخ تعویض</th>
              </tr>
            </thead>
            <tbody>
              {carChanges?.map((item) => (
                <tr
                  key={item?.id}
                  className="text-sm last:border-b-0 border-b bg-[#F7F9FB] dark:bg-slate-700"
                >
                  <td className="p-4 dark:text-white">{item?.service_type}</td>
                  <td className="p-4 dark:text-white">{item?.product?.name ?? '- - -'}</td>
                  <td className="p-4 dark:text-white">
                    {moment(item?.created_at?.split('T')[0]).format('jYYYY/jMM/jDD')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  )
}

export default memo(CarChangesModal)
